export class MaxRetentionDaysLimit {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "maxRetentionDays",
            "baseName": "maxRetentionDays",
            "type": "number",
            "format": "int32"
        }
    ];
    static getAttributeTypeMap() {
        return MaxRetentionDaysLimit.attributeTypeMap;
    }
    constructor() {
    }
}
